import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import UserProfileComponent from 'Components/UserProfile';
import MainLayout from 'Components/Layout/MainLayout';
import UserProfileTabs from 'Components/UserProfile/UserProfileTabs';
import UserJobAdvertisements from 'Components/UserProfile/UserJobAdvertisements';
import AllEmployers from 'Components/UserProfile/AllEmployers';
import Search from 'Components/Search';
import { RootState } from 'Store';

const ProfileContentRow = styled.div`
  max-width: 1440px;
  margin: auto;
  display: flex;
  flex-direction: column;
  @media screen and ${(props) => props.theme.breakpoints.xl} {
    flex-direction: row;
    align-items: flex-start;
    padding: 64px 32px 32px;
    gap: 32px;
  }
`;

const AllJobsLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
  padding: 12px 32px;
  background-color: #D73714;
  color: #ffffff;
  font-family: acumin-pro;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  text-decoration: none;
  text-align: center;
  border-radius: 6px;
  border: none;
  cursor: pointer;
`;

const JobAdvertisementsCard = styled.div`
  flex: 1;
  min-width: 0;
  margin: 0 16px 32px;
  min-width: 400px;
  @media screen and ${(props) => props.theme.breakpoints.xl} {
    margin: 0 0 32px;
  }
  > div {
    display: block;
    padding: 0;
  }
`;

const UserProfile = () => {
  const { t } = useTranslation();
  const { data } = useSelector((state: RootState) => state.jobAdvertisement);
  const { count } = data as any;

  return (
    <MainLayout>
      <Search type="job" />
      <UserProfileComponent />
      <ProfileContentRow>
        <UserProfileTabs />
        <JobAdvertisementsCard>
          <UserJobAdvertisements />
          <AllJobsLink to="/jobs">
            {t('show-all-job-advertisements', { count: count || 0 })}
          </AllJobsLink>
          <AllEmployers />
        </JobAdvertisementsCard>
      </ProfileContentRow>
    </MainLayout>
  );
};

export default UserProfile;
